export default __webpack_public_path__ + "static/media/skip-sound.1227f2fd.mp3";